
import { Placement } from '@post-office/placements-frontend/rovo-ops-alert-detail-spotlight';
export default Placement;
